import {useEffect,useState} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {
	cancelSubscription,
	selectCurrentStatus,
	getPurchasedSubscriptions,
	selectAllPurchasedSubscriptions,
	toggleClientSubscription
} from './activeSubscriptionsSlice'
import LocaleDate from '../../LocaleDate/LocaleDate'
import {useActiveSubscriptions} from '../hooks'
import CenteredLoader from '../../CenteredLoader/CenteredLoader'
import useCurrentUser from '../../../hooks/useCurrentUser'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Table from 'react-bootstrap/Table'

export const ActiveSubscription = ({subscription})=>{

	const dispatch = useDispatch()
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const handleCancel = ()=>{
		if(!window.confirm('Are you sure?')) return 
		dispatch(cancelSubscription({
			stripe_subscription_id:subscription.stripe_subscription_id,
			id:subscription.subscription_id
		}))
	}
	const handleToggle = ()=>{
		dispatch(toggleClientSubscription({
			id:subscription.subscription_id,
			enabled:subscription.paused,
		}))
	}
	return (
		<tr>
			<td>
				{subscription.product_name}
				{Boolean(subscription.paused)
						? ' (paused)'
						: ''
				}
			</td>
			{!isClient&&<td>{subscription.client_user_name}</td>}
			<td>{(subscription.payment_amount/100).toFixed(2)}</td>
			<td>
				<span className="mr-1">{subscription.payment_interval}</span>
				{Boolean(subscription.next_payment_date)&&
					<span>
						(
						<span className="mr-1">next payment:</span>
						<LocaleDate 
							date={new Date(subscription.next_payment_date.split(' ').join('T'))}
							includeTime={false}
						/>
						)
					</span>
				}
			</td>
			<td>
				<Button
					onClick={handleToggle}
					variant={
						Boolean(subscription.paused)
						? 'outline-success'
						: 'outline-dark'
					}
					size="sm"
				>
					{Boolean(subscription.paused)
						? 'resume'
						: 'pause'
					}
				</Button>
			</td>
			<td>
				<Button 
					onClick={handleCancel}
					variant="outline-danger"
					size="sm"
				>
					Cancel
				</Button>
			</td>
		</tr>
	)
}

const ActiveSubscriptions = ()=>{
	const dispatch = useDispatch()
	const {status,subscriptions} = useActiveSubscriptions()

	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const [filter,setFilter] = useState('')
	const matchesFilter = (sub)=>(
		filter === '' || 
		sub.client_name?.toLowerCase().includes(filter.toLowerCase()) ||
		sub.product_name?.toLowerCase().includes(filter.toLowerCase())
	)

	return (
		<div>
			<div style={{fontSize:'18px'}}>
				Active Subscriptions
			</div>
			{!isClient&&
				<div>
					<small>Search Subscriptions:</small>
					<Form.Control
						placeholder="search"
						onChange={e=>{
							setFilter(e.target.value)
						}}
						value={filter}
					/>
				</div>
			}
			<Table striped bordered hover className="bg-white mt-2">
				<thead className="bg-dark text-white">
					<tr>
						<td>Subscription</td>
						{!isClient&&<td>Client</td>}
						<td>Amount</td>
						<td>Billing Cycle</td>
						<td>Toggle</td>
						<td>Cancel</td>
					</tr>
				</thead>
				<tbody>
				{
					status === 'pending' ?
					<tr>
						<td colSpan="100%"><CenteredLoader/></td>
					</tr>
					:
					(
						subscriptions.length > 0 ?
						subscriptions
							.filter(matchesFilter)
							.map(
								sub => <ActiveSubscription subscription={sub}/>
							)
						:
						<tr>
							<td colSpan="100%">
								No current subscriptions
							</td>
						</tr>
					)
				}
				</tbody>
			</Table>
		</div>
	)
}

export default ActiveSubscriptions